import { pbxGroup } from "core/UrlEndpoints";
import CrudService from "./CrudService";
import { fetchDataJson } from "../FetchApi";

class PbxGroupService extends CrudService {
  constructor() {
    super(pbxGroup);
  }

  async filterByName(name) {
    return fetchDataJson(`${pbxGroup}?size=${50}&page=${1}&filter[Name]=${name}*`, {
      method: "GET",
    });
  }

  async getWithAmiInfo(id) {
    return fetchDataJson(`${pbxGroup}/${id}/WithAmiInfo`, {
      method: "GET",
    });
  }

}

export default new PbxGroupService();
